import React from 'react'
import Accordions from '../../../components/Accordions'


const Sem7Aiml = () => {
  const data = [
    // {
    //   subjectName: "2021 Batch",
    //   units: [ ],
    //   links: [
    //     {
    //       url: "",
    //       title: "Syllabus",
    //     },
    //   ],
    // },
    {
      subjectName: "2022 Batch",
      units: [],
      links: [
        {
          url: "https://drive.google.com/file/d/18jw3_i23H9q89lshWo8L7spBC0tgHi8X/view?usp=drive_link",
          title: "Syllabus",
        },
      ],
    },
    ];
  return (
    <div className="min-h-screen pt-12 m-auto w-[90%]">
      <h1 className="text-xl font-semibold flex justify-center">AIML Sem - 7</h1>
      <Accordions data={data} />
    </div>
  );
};

export default Sem7Aiml